import { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../lib/firebaseClient';

const COLLECTION_NAME = 'pantry_items';

/**
 * Real-time subscription hook for pantry items
 * Returns live data that updates automatically when Firestore changes
 */
export const usePantryItems = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Create a query that orders by name
    const q = query(
      collection(db, COLLECTION_NAME),
      orderBy('name', 'asc')
    );

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const pantryItems = [];
        snapshot.forEach((doc) => {
          pantryItems.push({
            id: doc.id,
            ...doc.data(),
            // Convert Firestore timestamps to Date objects for easier handling
            createdAt: doc.data().createdAt?.toDate?.() || doc.data().createdAt,
            updatedAt: doc.data().updatedAt?.toDate?.() || doc.data().updatedAt,
            expirationDate: doc.data().expirationDate?.toDate?.() || doc.data().expirationDate,
          });
        });
        setItems(pantryItems);
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching pantry items:', err);
        setError(err);
        setLoading(false);
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  return { items, loading, error };
};







